import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Socket } from 'socket.io-client';

/**
 * Hook to synchronize language changes from the server
 * Listens to 'language:changed' events and updates i18next
 */
export function useLanguageSync(socket: Socket | null, isConnected: boolean) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!socket || !isConnected) return;

    const handleLanguageChange = (data: { language: string }) => {
      console.log(`[LANGUAGE-SYNC] Language changed to: ${data.language}`);
      i18n.changeLanguage(data.language);
      localStorage.setItem('i18nextLng', data.language);
    };

    socket.on('language:changed', handleLanguageChange);

    return () => {
      socket.off('language:changed', handleLanguageChange);
    };
  }, [socket, isConnected, i18n]);
}
